import React from 'react';
import { Table, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import '../../css/pdfLibrary.css';

const PdfLibrary = ({ data }) => {

    if (!data || data.length === 0) {
        return null;
    }

    const columns = [
        { title: 'Title', dataIndex: 'title', key: 'title' },
        { title: 'Date', dataIndex: 'date', key: 'date' },
        {
            title: 'Download',
            dataIndex: 'download',
            key: 'download',
            render: (text, record) => (
                <a href={record.download} target="_blank" rel="noopener noreferrer">
                    <Button type="primary" className="download-btn" icon={<DownloadOutlined />} />
                </a>
            )
        }
    ];

    const dataSource = data.map((item) => ({
        key: item.id,
        title: item.title,
        date: item.date,
        download: item.pdf?.data?.attributes?.url || '#',
    }));

    return (
        <div className="pdf-library-table">
            <Table dataSource={dataSource} columns={columns} pagination={false} bordered />
        </div>
    );
};

export default PdfLibrary;